import { ScoringForm } from './ScoringForm';
import { ReportTemplate } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/ReportTemplate';
import { Reader } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/Reader';
import { Measurement } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/Measurement';
import { Instrument } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/Instrument';
import { Dictionary } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/Dictionary';
import { FunctionReadingInventory } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/FunctionReadingInventory';

export const renderInventorySchema = {
  'scoring-forms': {
    element: ScoringForm,
    defaultValues: {
      viewerEmbedded: false,
      schema: {},
      extractor: '',
      signRequired: true,
      groupCode: null,
    },
  },
  tags: {
    defaultValues: {},
    element: () => <></>,
  },
  functions: {
    defaultValues: { groupCode: null },
    element: FunctionReadingInventory,
  },
  measurements: {
    defaultValues: {
      scoringFormId: '',
      screenshotRequired: false,
      allowNaScreenshot: false,
      maxAllowance: 0,
      minRequired: 1,
      namePattern: '',
      metadata: {},
    },
    element: Measurement,
  },
  readers: {
    defaultValues: {
      dynamikaUserId: '',
      alias: '',
    },
    element: Reader,
  },
  instruments: {
    defaultValues: {
      scoringFormId: '',
      forImagingSpecialist: false,
      forReader: false,
      runnable: false,
      workflowType: null,
      workflowName: null,
    },
    element: Instrument,
  },
  'report-templates': {
    defaultValues: {
      template: '',
    },
    element: ReportTemplate,
  },
  dictionaries: {
    element: Dictionary,
    defaultValues: {
      type: '',
      json: {},
    },
  },
};
